export default __webpack_public_path__ + "2abc7664fc29dfa1930a360dd61c823d.webp";